import { useState } from 'react';

import { useAppSelector } from '@pkg/hooks';

import { type ResourceId } from '@app/client';
import { useSubscribeToTopic, WebsocketTopicIds } from '@app/helpers';
import { type WebsocketMessage, WebsocketTopic } from '@app/store/types/websockets';

const FREE_YAT_HANDLER_TOPIC = 'freeYatHandler';
interface FreeYatWsData {
    data: {
        free_yat: string;
        user_id: ResourceId;
    };
}
export function useUpdateFreeYat() {
    const currentUserId = useAppSelector((state) => state.user?.userAccount?.user.id);
    const [freeYatValue, setFreeYatValue] = useState<string>();

    const onmessage = (message) => {
        try {
            const websocketMessage: WebsocketMessage = JSON.parse(message.data);
            const { topic, payload } = websocketMessage;
            const isFreeYatTopic = topic && topic === WebsocketTopic.FreeYatAssigned;
            if (isFreeYatTopic) {
                // eslint-disable-next-line no-console
                console.debug(`WS Topic FreeYatAssigned`);
                const freeYatData = payload as unknown as FreeYatWsData;
                if (freeYatData.data.free_yat && freeYatData.data.user_id === currentUserId) {
                    setFreeYatValue(freeYatData.data.free_yat);
                }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    useSubscribeToTopic({
        id: WebsocketTopicIds.FreeYatAssigned,
        topic: WebsocketTopic.FreeYatAssigned,
        messageKey: FREE_YAT_HANDLER_TOPIC,
        onmessage,
    });

    return { freeYatValue };
}
